export default "__VITE_ASSET__def03a6f__"